const apiBase = () => process.env.REACT_APP_BASE_API_URL || '';

/**
 * Повна адреса файлу.
 *
 * Медіа CMS приходить відносною адресою (`/uploads/banner.png`) і потребує
 * домену; медіа e-phan — уже готовим посиланням на чужий домен. Відколи
 * календар змішує два джерела, склеювати з `apiBase` наосліп не можна: банер
 * змагання перетворився б на `http://localhost:1337https://api.e-phan.com/...`.
 */
export function mediaUrl(url) {
  if (!url) return null;
  if (/^(https?:)?\/\//.test(url) || url.startsWith('data:')) return url;

  return `${apiBase()}${url}`;
}
